var exports = {
  "kL": "x0a7806d5--9c2b9d--container",
  "nV": "x0a7806d5--9c2b9d--gallery",
  "Nl": "x0a7806d5--9c2b9d--builder-info",
  "WD": "x0a7806d5--9c2b9d--labels",
  "cq": "x0a7806d5--9c2b9d--phone-button",
};

module.exports = exports;
